export default [
  {
    label: "🇩🇿 Algeria - French",
    shortLabel: "🇩🇿 DZ",
    value: "dz:fr",
  },
  {
    label: "🇦🇴 Angola",
    shortLabel: "🇦🇴 AO",
    value: "ao:pt",
  },
  {
    label: "🇦🇷 Argentina",
    shortLabel: "🇦🇷 AR",
    value: "ar:es",
  },
  {
    label: "🇦🇺 Australia",
    shortLabel: "🇦🇺 AU",
    value: "au:en",
  },
  {
    label: "🇦🇹 Austria",
    shortLabel: "🇦🇹 AT",
    value: "at:de",
  },
  {
    label: "🇧🇪 Belgium - French",
    shortLabel: "🇧🇪 BE",
    value: "be:fr",
  },
  {
    label: "🇧🇪 Belgium - Dutch",
    shortLabel: "🇧🇪 BE",
    value: "be:nl",
  },
  {
    label: "🇧🇪 Belgium - German",
    shortLabel: "🇧🇪 BE",
    value: "be:de",
  },
  {
    label: "🇧🇴 Bolivia",
    shortLabel: "🇧🇴 BO",
    value: "bo:es",
  },
  {
    label: "🇧🇷 Brazil",
    shortLabel: "🇧🇷 BR",
    value: "br:pt",
  },
  {
    label: "🇧🇫 Burkina Faso",
    shortLabel: "🇧🇫 BF",
    value: "bf:fr",
  },
  {
    label: "🇰🇭 Cambodia",
    shortLabel: "🇰🇭 KH",
    value: "kh:en",
  },
  {
    label: "🇨🇲 Cameroon",
    shortLabel: "🇨🇲 CM",
    value: "cm:fr",
  },
  {
    label: "🇨🇦 Canada - English",
    shortLabel: "🇨🇦 CA",
    value: "ca:en",
  },
  {
    label: "🇨🇦 Canada - French",
    shortLabel: "🇨🇦 CA",
    value: "ca:fr",
  },
  {
    label: "🇨🇱 Chile",
    shortLabel: "🇨🇱 CL",
    value: "cl:es",
  },
  {
    label: "🇨🇴 Colombia",
    shortLabel: "🇨🇴 CO",
    value: "co:es",
  },
  {
    label: "🇨🇷 Costa Rica",
    shortLabel: "🇨🇷 CR",
    value: "cr:es",
  },
  {
    label: "🇨🇮 Cote d'Ivoire",
    shortLabel: "🇨🇮 CI",
    value: "ci:fr",
  },
  {
    label: "🇭🇷 Croatia",
    shortLabel: "🇭🇷 HR",
    value: "hr:hr",
  },
  {
    label: "🇨🇾 Cyprus - Greek",
    shortLabel: "🇨🇾 CY",
    value: "cy:el",
  },
  {
    label: "🇨🇾 Cyprus - English",
    shortLabel: "🇨🇾 CY",
    value: "cy:en",
  },
  {
    label: "🇩🇰 Denmark",
    shortLabel: "🇩🇰 DK",
    value: "dk:da",
  },
  {
    label: "🇪🇨 Ecuador",
    shortLabel: "🇪🇨 EC",
    value: "ec:es",
  },
  {
    label: "🇪🇬 Egypt - English",
    shortLabel: "🇪🇬 EG",
    value: "eg:en",
  },
  {
    label: "🇸🇻 El Salvador",
    shortLabel: "🇸🇻 SV",
    value: "sv:es",
  },
  {
    label: "🇪🇪 Estonia",
    shortLabel: "🇪🇪 EE",
    value: "ee:et",
  },
  {
    label: "🇫🇮 Finland",
    shortLabel: "🇫🇮 FI",
    value: "fi:fi",
  },
  {
    label: "🇫🇷 France",
    shortLabel: "🇫🇷 FR",
    value: "fr:fr",
  },
  {
    label: "🇩🇪 Germany",
    shortLabel: "🇩🇪 DE",
    value: "de:de",
  },
  {
    label: "🇬🇭 Ghana",
    shortLabel: "🇬🇭 GH",
    value: "gh:en",
  },
  {
    label: "🇬🇷 Greece",
    shortLabel: "🇬🇷 GR",
    value: "gr:el",
  },
  {
    label: "🇬🇹 Guatemala",
    shortLabel: "🇬🇹 GT",
    value: "gt:es",
  },
  {
    label: "🇭🇺 Hungary",
    shortLabel: "🇭🇺 HU",
    value: "hu:hu",
  },
  {
    label: "🇮🇳 India - English",
    shortLabel: "🇮🇳 IN",
    value: "in:en",
  },
  {
    label: "🇮🇩 Indonesia - English",
    shortLabel: "🇮🇩 ID",
    value: "id:en",
  },
  {
    label: "🇮🇪 Ireland",
    shortLabel: "🇮🇪 IE",
    value: "ie:en",
  },
  {
    label: "🇮🇹 Italy",
    shortLabel: "🇮🇹 IT",
    value: "it:it",
  },
  {
    label: "🇰🇿 Kazakhstan",
    shortLabel: "🇰🇿 KZ",
    value: "kz:ru",
  },
  {
    label: "🇰🇪 Kenya",
    shortLabel: "🇰🇪 KE",
    value: "ke:en",
  },
  {
    label: "🇲🇾 Malaysia - English",
    shortLabel: "🇲🇾 MY",
    value: "my:en",
  },
  {
    label: "🇲🇹 Malta",
    shortLabel: "🇲🇹 MT",
    value: "mt:en",
  },
  {
    label: "🇲🇽 Mexico",
    shortLabel: "🇲🇽 MX",
    value: "mx:es",
  },
  {
    label: "🇲🇲 Myanmar (Burma)",
    shortLabel: "🇲🇲 MM",
    value: "mm:en",
  },
  {
    label: "🇳🇱 Netherlands",
    shortLabel: "🇳🇱 NL",
    value: "nl:nl",
  },
  {
    label: "🇳🇿 New Zealand",
    shortLabel: "🇳🇿 NZ",
    value: "nz:en",
  },
  {
    label: "🇳🇮 Nicaragua",
    shortLabel: "🇳🇮 NI",
    value: "ni:es",
  },
  {
    label: "🇳🇬 Nigeria",
    shortLabel: "🇳🇬 NG",
    value: "ng:en",
  },
  {
    label: "🇵🇰 Pakistan - English",
    shortLabel: "🇵🇰 PK",
    value: "pk:en",
  },
  {
    label: "🇵🇾 Paraguay",
    shortLabel: "🇵🇾 PY",
    value: "py:es",
  },
  {
    label: "🇵🇪 Peru",
    shortLabel: "🇵🇪 PE",
    value: "pe:es",
  },
  {
    label: "🇵🇭 Philippines - English",
    shortLabel: "🇵🇭 PH",
    value: "ph:en",
  },
  {
    label: "🇵🇱 Poland",
    shortLabel: "🇵🇱 PL",
    value: "pl:pl",
  },
  {
    label: "🇵🇹 Portugal",
    shortLabel: "🇵🇹 PT",
    value: "pt:pt",
  },
  {
    label: "🇷🇴 Romania",
    shortLabel: "🇷🇴 RO",
    value: "ro:ro",
  },
  {
    label: "🇸🇳 Senegal",
    shortLabel: "🇸🇳 SN",
    value: "sn:fr",
  },
  {
    label: "🇸🇬 Singapore - English",
    shortLabel: "🇸🇬 SG",
    value: "sg:en",
  },
  {
    label: "🇿🇦 South Africa",
    shortLabel: "🇿🇦 ZA",
    value: "za:en",
  },
  {
    label: "🇪🇸 Spain",
    shortLabel: "🇪🇸 ES",
    value: "es:es",
  },
  {
    label: "🇱🇰 Sri Lanka",
    shortLabel: "🇱🇰 LK",
    value: "lk:en",
  },
  {
    label: "🇸🇪 Sweden",
    shortLabel: "🇸🇪 SE",
    value: "se:sv",
  },
  {
    label: "🇨🇭 Switzerland - German",
    shortLabel: "🇨🇭 CH",
    value: "ch:de",
  },
  {
    label: "🇨🇭 Switzerland - French",
    shortLabel: "🇨🇭 CH",
    value: "ch:fr",
  },
  {
    label: "🇹🇷 Turkey",
    shortLabel: "🇹🇷 TR",
    value: "tr:tr",
  },
  {
    label: "🇺🇦 Ukraine - Ukrainian",
    shortLabel: "🇺🇦 UA",
    value: "ua:uk",
  },
  {
    label: "🇺🇦 Ukraine - Russian",
    shortLabel: "🇺🇦 UA",
    value: "ua:ru",
  },
  {
    label: "🇦🇪 United Arab Emirates - English",
    shortLabel: "🇦🇪 AE",
    value: "ae:en",
  },
  {
    label: "🇬🇧 United Kingdom",
    shortLabel: "🇬🇧 GB",
    value: "gb:en",
  },
  {
    label: "🇺🇸 United States - English",
    shortLabel: "🇺🇸 US",
    value: "us:en",
  },
  {
    label: "🇺🇸 United States - Spanish",
    shortLabel: "🇺🇸 US",
    value: "us:es",
  },
  {
    label: "🇺🇾 Uruguay",
    shortLabel: "🇺🇾 UY",
    value: "uy:es",
  },
  {
    label: "🇻🇪 Venezuela",
    shortLabel: "🇻🇪 VE",
    value: "ve:es",
  },
  {
    label: "🇻🇳 Vietnam - English",
    shortLabel: "🇻🇳 VN",
    value: "vn:en",
  },
];
